<script>
import {mapActions, mapState} from "pinia";
import {mainSearchStore} from "@/store/mainSearchStore";
import Skeleton from 'primevue/skeleton';
import ProposalListItem from "@/components/MainSearch/SearchResult/Proposal/ProposalListItem.vue";
import MainSearchNoResults from "@/components/MainSearch/SearchResult/MainSearchNoResults.vue";

export default {
  name: "ProposalListAll",
  components: {
    Skeleton,
    ProposalListItem,
    MainSearchNoResults
  },
  computed: {
    ...mapState(mainSearchStore, [
      'searchParams',
      'searchResultProposalAll'
    ]),
    searchResultIdentity() {
      return this.searchResultProposalAll.find(list => list.type === 'IDENTITY');
    },
    searchResultCreator() {
      return this.searchResultProposalAll.find(list => list.type === 'CREATOR');
    },
    searchResultSubjects() {
      return this.searchResultProposalAll.find(list => list.type === 'SUBJECTS');
    },
  },
  methods: {
    ...mapActions(mainSearchStore, [
      'runSearch',
      'updateSearchParams'
    ])
  },
  mounted() {
    this.runSearch();
  }
}
</script>

<template>
  <div class="mb-20">
    <span class="search-type-label">{{$t('mainSearch.searchByFilter.title')}}:</span>
    <template v-if="searchResultIdentity.state">
      <template v-if="searchResultIdentity.result.length > 0">
        <proposal-list-item v-for="item in searchResultIdentity.result"
                            :key="item.id"
                            :item-data="item"
        />
        <span v-if="searchResultIdentity.showAllState" @click="updateSearchParams('searchMode', 'IDENTITY')" class="show-more">
          {{$t('mainSearch.seeMoreResults')}}
        </span>
      </template>
      <template v-else>
        <main-search-no-results :search-string="searchParams.searchString"/>
      </template>
    </template>
    <template v-else>
      <Skeleton height="2rem" class="mb-2"></Skeleton>
      <Skeleton height="2rem" class="mb-2"></Skeleton>
      <Skeleton height="2rem" class="mb-2"></Skeleton>
    </template>
  </div>
  <div class="mb-20">
    <span class="search-type-label">{{$t('mainSearch.searchByFilter.creator')}}:</span>
    <template v-if="searchResultCreator.state">
      <template v-if="searchResultCreator.result.length > 0">
        <proposal-list-item v-for="item in searchResultCreator.result"
                            :key="item.id"
                            :item-data="item"
        />
        <span v-if="searchResultCreator.showAllState" @click="updateSearchParams('searchMode', 'CREATOR')" class="show-more">
          {{$t('mainSearch.seeMoreResults')}}
        </span>
      </template>
      <template v-else>
        <main-search-no-results :search-string="searchParams.searchString"/>
      </template>
    </template>
    <template v-else>
      <Skeleton height="2rem" class="mb-2"></Skeleton>
      <Skeleton height="2rem" class="mb-2"></Skeleton>
      <Skeleton height="2rem" class="mb-2"></Skeleton>
    </template>
  </div>
  <div class="mb-20">
    <span class="search-type-label">{{$t('mainSearch.searchByFilter.subjects')}}:</span>
    <template v-if="searchResultSubjects.state">
      <template v-if="searchResultSubjects.result.length > 0">
        <proposal-list-item v-for="item in searchResultSubjects.result"
                            :key="item.id"
                            :item-data="item"
        />
        <span v-if="searchResultSubjects.showAllState" @click="updateSearchParams('searchMode', 'SUBJECTS')" class="show-more">
          {{$t('mainSearch.seeMoreResults')}}
        </span>
      </template>
      <template v-else>
        <main-search-no-results :search-string="searchParams.searchString"/>
      </template>
    </template>
    <template v-else>
      <Skeleton height="2rem" class="mb-2"></Skeleton>
      <Skeleton height="2rem" class="mb-2"></Skeleton>
      <Skeleton height="2rem" class="mb-2"></Skeleton>
    </template>
  </div>
</template>

<style lang="scss" scoped>
.search-type-label {
  display: inline-block;
  margin-bottom: 10px;
  font-size: 14px;
  font-weight: 600;
}

.show-more {
  padding-top: 10px;
  font-size: 14px;
  font-weight: 600;
  color: #7835a6;
  cursor: pointer;
}
</style>